/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Library } from '../../Library';
import { AbstractCommand } from '../AbstractCommand';
import { ModelUtils } from '../util/ModelUtils';
import { CombinedVisitorAdapter } from '../../combined/visitors/CombinedVisitorAdapter';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { NodeCompat } from '../../compat/NodeCompat';
import { Document } from '../../core/models/Document';
import { NodePath } from '../../core/models/NodePath';
import { VisitorUtil } from '../../core/util/VisitorUtil';
import { TraverserDirection } from '../../core/visitors/TraverserDirection';
import { OasDocument } from '../../openapi/models/OasDocument';
import { OasResponse } from '../../openapi/models/OasResponse';
import { Node } from '../../core/models/Node';

/**
 * A command used to rename a response definition, along with all references to it.
 * @author eric.wittmann@gmail.com
 * @extends AbstractCommand
 * @class
 */
export abstract class RenameResponseDefinitionCommand extends AbstractCommand {
    public _oldName : string;

    public _newName : string;

    public _references : Array<NodePath>;

    public constructor(oldName? : any, newName? : any) {
        if(((typeof oldName === 'string') || oldName === null) && ((typeof newName === 'string') || newName === null)) {
            let __args = arguments;
            super();
            if(this._oldName===undefined) this._oldName = null;
            if(this._newName===undefined) this._newName = null;
            if(this._references===undefined) this._references = null;
            if(this._oldName===undefined) this._oldName = null;
            if(this._newName===undefined) this._newName = null;
            if(this._references===undefined) this._references = null;
            (() => {
                this._oldName = oldName;
                this._newName = newName;
            })();
        } else if(oldName === undefined && newName === undefined) {
            let __args = arguments;
            super();
            if(this._oldName===undefined) this._oldName = null;
            if(this._newName===undefined) this._newName = null;
            if(this._references===undefined) this._references = null;
            if(this._oldName===undefined) this._oldName = null;
            if(this._newName===undefined) this._newName = null;
            if(this._references===undefined) this._references = null;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#execute(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[RenameResponseDefinitionCommand] Executing.");
        this._references = <any>([]);
        if(this._renameResponseDefinition(<OasDocument>document, this._oldName, this._newName)) {
            let oldRef : string = this._nameToReference(this._oldName);
            let newRef : string = this._nameToReference(this._newName);
            let responseFinder : RenameResponseDefinitionCommand.ResponseRefFinder = new RenameResponseDefinitionCommand.ResponseRefFinder(oldRef);
            let responses : Array<OasResponse> = responseFinder.findIn(document);
            for(let index155=0; index155 < responses.length; index155++) {
                let response = responses[index155];
                {
                    /* add */(this._references.push(Library.createNodePath(response))>0);
                    response.$ref = newRef;
                }
            }
        }
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#undo(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[RenameResponseDefinitionCommand] Reverting.");
        if(this._renameResponseDefinition(<OasDocument>document, this._newName, this._oldName)) {
            let oldRef : string = this._nameToReference(this._oldName);
            if(ModelUtils.isDefined(this._references)) {
                this._references.forEach(((oldRef) => {
                    return (ref) => {
                        let response : OasResponse = <OasResponse>ref.resolve(document);
                        response.$ref = oldRef;
                    }
                })(oldRef));
            }
        }
    }

    /**
     * Convert a simple name to a reference.  This will be different for 2.0 vs. 3.0
     * data models.
     * @param {string} name
     * @return {string}
     */
    abstract _nameToReference(name : string) : string;

    /**
     * Called to actually change the name of the response definition.  This impl will vary
     * depending on the OAI data model version.  Returns true if the rename actually happened.
     * @param {OasDocument} document
     * @param {string} fromName
     * @param {string} toName
     * @return {boolean}
     */
    abstract _renameResponseDefinition(document : OasDocument, fromName : string, toName : string) : boolean;
}
RenameResponseDefinitionCommand["__class"] = "io.apicurio.datamodels.cmd.commands.RenameResponseDefinitionCommand";
RenameResponseDefinitionCommand["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];



export namespace RenameResponseDefinitionCommand {

    /**
     * Constructor.
     * @param {string} reference
     * @class
     * @extends CombinedVisitorAdapter
     */
    export class ResponseRefFinder extends CombinedVisitorAdapter {
        _reference : string;

        _responses : Array<OasResponse> = <any>([]);

        public constructor(reference : string) {
            super();
            if(this._reference===undefined) this._reference = null;
            this._reference = reference;
        }

        public findIn(document : Document) : Array<OasResponse> {
            VisitorUtil.visitTree(document, this, TraverserDirection.down);
            return this._responses;
        }

        _accept(response : OasResponse) : boolean {
            return ModelUtils.isDefined(response.$ref) && NodeCompat.equals(response.$ref, this._reference);
        }

        /**
         * @see io.apicurio.datamodels.combined.visitors.CombinedVisitorAdapter#visitResponse(io.apicurio.datamodels.openapi.models.OasResponse)
         * @param {OasResponse} node
         */
        public visitResponse(node : OasResponse) {
            if(this._accept(node)) {
                /* add */(this._responses.push(node)>0);
            }
        }
    }
    ResponseRefFinder["__class"] = "io.apicurio.datamodels.cmd.commands.RenameResponseDefinitionCommand.ResponseRefFinder";
    ResponseRefFinder["__interfaces"] = ["io.apicurio.datamodels.core.visitors.IVisitor","io.apicurio.datamodels.asyncapi.v2.visitors.IAai20Visitor","io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor","io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor","io.apicurio.datamodels.openapi.v2.visitors.IOas20Visitor","io.apicurio.datamodels.openapi.visitors.IOasVisitor"];


}



